import store from '@/store'
const commonView = () => import(/* webpackChunkName: "common" */ '@/views/acount')
const addAcount = () => import(/* webpackChunkName: "acout" */  '@/views/acount/add-acount.vue')
const acounttb = () => import(/* webpackChunkName: "acout" */  '@/views/acount/list')
const maintainRecord = () => import(/* webpackChunkName: "acout" */ '@/views/acount/maintain-record.vue')
const siteMaintain = () => import(/* webpackChunkName: "acout" */ '@/views/acount/site-maintain.vue')
const gameManagement = () => import(/* webpackChunkName: "game-management" */ '@/views/acount/game-management.vue')

const acoutLeading = {
  path: 'acout',
  name: 'acout',
  component: commonView,
  meta: { title: '营运站点管理' },
  redirect: '/main/:GD/website-management/acout/list',
  beforeEnter: (to, from, next) => {
    if (store.getters.getpermission.member[0] != '1') return next({ name: 'no-permission', params: to.params })
    next()
  },
  children: [
    {
      path: 'list',
      component: acounttb,
      name: 'list',
      meta: { title: '营运站点管理' }
    },
    {
      path: 'add-acount',
      component: addAcount,
      name: 'add-acount',
      meta: { title: '新增站点' }
    },
    {
      path: 'game-management',
      component: gameManagement,
      name: 'game-management',
      meta: { title: '遊戲管理' }
    },
    {
      path: 'maintain-record',
      component: maintainRecord,
      name: 'maintain-record',
      meta: { title: '维护历程纪录' }
    },
    {
      path: 'site-maintain',
      component: siteMaintain,
      name: 'site-maintain',
      meta: { title: '网站维护' }
    },
  ]
}

export default acoutLeading